import { ClassScheduleView } from "../schedule/ClassScheduleView";
import { seniorSchedule } from "../schedule/data";

export const RaspisanieHight = () => <ClassScheduleView schedule={seniorSchedule} />;
